import { useEffect, useState } from "react";
import { findEntityData } from "../../api/apiService";
import tickIcon from "../../assets/a1.webp";

const AboutSection = () => {
    const [section1, setSection1] = useState()
    const findData = async () => {
        const res = await findEntityData('sss_about_header')
        setSection1(res?.data?.[0])
    }

    useEffect(() => {
        findData()
    }, [])
    return (
        <section id={section1?.sectionName} className="py-12 px-4">
            {section1 &&
                <>
                    <div className="text-center mb-10">
                        <h1
                            className="text-3xl md:text-4xl font-semibold text-[#F37934]"
                            data-aos="zoom-in"
                            data-aos-duration="800"
                            data-aos-easing="ease-out"
                        >
                            'ABOUT US'
                        </h1>

                        <div className="mt-4 inline-block">
                            <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-[#56453F] to-transparent mb-2"></div>
                            <p className="text-lg p-2 font-semibold text-[#56453F]">
                                {section1?.heading}
                            </p>
                            <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-[#56453F] to-transparent mt-2"></div>
                        </div>
                    </div>

                    <div className="max-w-4xl mx-auto text-lg space-y-8 leading-relaxed">
                        <p className="text-center">
                            <div dangerouslySetInnerHTML={{ __html: section1?.content }} />
                        </p>
                        <div className="flex flex-col items-center sm:items-start space-y-4 sm:space-y-6 pl-0 sm:pl-12 md:pl-24 font-semibold">
                            {section1?.data?.map((item, i) => (
                                <div
                                    key={i}
                                    className="inline-flex items-center sm:items-start justify-center sm:justify-start gap-3 border border-white bg-gradient-to-r from-[#F0F0E5] via-[#FFFFFF] to-[#F0F0E5] rounded-full w-full sm:w-fit p-3 sm:p-4 mx-auto sm:mx-0"
                                    data-aos={i % 2 === 0 ? "slide-left" : "slide-right"}
                                    data-aos-duration="800"
                                >
                                    <img src={tickIcon} alt="tick" className="w-5 h-5 sm:w-6 sm:h-6 mt-1" />
                                    <p className="text-sm sm:text-base text-center sm:text-left">{item?.content}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </>}
        </section>
    );
};

export default AboutSection;
